import React from 'react'
import DynamicColor from '../common/dynamic-color'

import { COLOR_NAME } from '../../constants'
import { clsx } from '../../utils/helper'

const Checkbox = ({ checked = false, square }) => {
    return (
        <DynamicColor
            className={clsx(['check-box', square && 'square'])}
            style={{
                borderColor: COLOR_NAME.BODY_TEXT,
            }}
        >
            {checked && (
                <DynamicColor
                    style={{ backgroundColor: COLOR_NAME.BUTTON_BG }}
                    className="check-box--checked"
                />
            )}
        </DynamicColor>
    )
}

export default Checkbox
